module.exports = __webpack_public_path__ + "img/msla.7e423c6b.png";